import { OvTableData } from '../../../components/UI/molecules/OvTable';
import i18n from '../../../i18n/config';
import { StrawStageContent } from '../../model/dto/straw-stage-content';
import { TableRowEditWidgetType } from '../../model/ui/table-row-edit-widget.type';

export class StrawStageContentDataUtils {
  static mapStrawStageContentToTableData(
    strawStageContent?: StrawStageContent
  ): OvTableData {
    return [
      {
        label: 'strawStageContents.fields.strawStage',
        value: strawStageContent?.straw_stage,
        translateLabel: true,
      },
      {
        label: 'strawStageContents.fields.cluster',
        value: strawStageContent?.cluster,
        translateLabel: true,
      },
      {
        label: 'strawStageContents.fields.name',
        value: strawStageContent?.name,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'name',
          placeholder: i18n.t('strawStageContents.fields.name'),
        },
      },
      {
        label: 'strawStageContents.fields.description',
        value: strawStageContent?.description,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.FORMATTED_TEXT_AREA,
          propertyName: 'description',
          placeholder: i18n.t('strawStageContents.fields.description'),
        },
      },
      {
        label: 'strawStageContents.fields.predictedPhaseLength',
        value: strawStageContent?.predicted_phase_length,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'predicted_phase_length',
          placeholder: i18n.t('strawStageContents.fields.predictedPhaseLength'),
        },
      },
      {
        label: 'strawStageContents.fields.disclaimerTitle',
        value: strawStageContent?.disclaimer_title,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'disclaimer_title',
          placeholder: i18n.t('strawStageContents.fields.disclaimerTitle'),
        },
      },
      {
        label: 'strawStageContents.fields.disclaimerContent',
        value: strawStageContent?.disclaimer_content,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'disclaimer_content',
          placeholder: i18n.t('strawStageContents.fields.disclaimerContent'),
        },
      },
      {
        label: 'strawStageContents.fields.cyclePatternsToWatch',
        value: strawStageContent?.cycle_patterns_to_watch,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT_ARRAY,
          propertyName: 'cycle_patterns_to_watch',
          placeholder: i18n.t('strawStageContents.fields.cyclePatternsToWatch'),
        },
      },
      {
        label: 'strawStageContents.fields.predictedSymptoms',
        value: strawStageContent?.predicted_symptoms,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT_ARRAY,
          propertyName: 'predicted_symptoms',
          placeholder: i18n.t('strawStageContents.fields.predictedSymptoms'),
        },
      },
      {
        label: 'strawStageContents.fields.careOptions',
        value: strawStageContent?.care_options,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT_ARRAY,
          propertyName: 'care_options',
          placeholder: i18n.t('strawStageContents.fields.careOptions'),
        },
      },
    ];
  }
}
